const state = () => ({
  saveRegistrationEvent: 0,
  saveClientRegistrationEvent: 0,
  updatePetDetailEvent: 0,
  updatePetNoteEvent: 0,
  bookAppointmentEvent: 0,
  bookingAddedEvent: null
})

const mutations = {
  triggerSaveRegistration (state) {
    state.saveRegistrationEvent++
  },
  triggerSaveClientRegistration (state) {
    state.saveClientRegistrationEvent++
  },
  triggerUpdatePetDetail (state) {
    state.updatePetDetailEvent++
  },
  triggerUpdatePetNote (state) {
    state.updatePetNoteEvent++
  },
  triggerBookAppointment (state) {
    state.bookAppointmentEvent++
  },
  triggerBookingAdded (state, booking) {
    state.bookingAddedEvent = booking
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
